import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    TranscriptSummaryDelete as TranscriptSummaryDeleteMutation,
    TranscriptSummaryDeleteVariables as TranscriptSummaryDeleteVariables,
    TranscriptSummaryDeleteInput,
} from 'nutshell-graphql-types';

import TRANSCRIPT_SUMMARY_DELETE from '../mutations/delete-transcript-summary.graphql';

export const useDeleteTranscriptSummary = (): {
    deleteTranscriptSummary: (arg1: TranscriptSummaryDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deleteTranscriptSummary, {loading, error}] = useMutation<
        TranscriptSummaryDeleteMutation,
        TranscriptSummaryDeleteVariables
    >(TRANSCRIPT_SUMMARY_DELETE);

    return {
        deleteTranscriptSummary: (input: TranscriptSummaryDeleteInput) =>
            deleteTranscriptSummary({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
